<template>
  <div class="pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3">
    <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
      <v-col xl="8" lg="9" md="11" sm="12" cols="12" class="mt-xl-8 mt-lg-8 mt-md-8">
        <v-skeleton-loader v-for="i in 10" type="list-item-avatar-three-line" :key="i + '_item'"></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ListLoader'
}
</script>
